import {doc} from './docs.js';

doc(
    "store",
    {
        "bang": "",
        "stored message": ""
    },
    "Stores a message until it receives a bang, which triggers it to send that stored message",
    undefined,
    {
        tags: "Messages",
        inlets: 2
    });

export const store = (object, stored) => {
    return ([msg]) => {
        if (msg === 'bang') {
            if (stored() === undefined) {
                return;
            }
            return [stored()];
        }
    };
};


